import moment from "moment-timezone";
export default {
  selectFormVesselNameProps: state => {
    return state.selectFormVesselNameProps
  },

  selectedVesselNames: state => {
    return state.selectedVesselNames
  },

  selectFormSenderProps: state => {
    return state.selectFormSenderProps
  },

  selectedSenders: state => {
    return state.selectedSenders
  },

  selectFormStatusProps: state => {
    return state.selectFormStatusProps
  },

  selectedStatus: state => {
    return state.selectedStatus
  },

  dateRangeUTC: state => {
    return state.dateRange
  },

  dateRangeJST: state => {
    let range = {
      start: moment(state.dateRange.start).tz("Asia/Tokyo").toDate(),
      end: moment(state.dateRange.end).tz("Asia/Tokyo").toDate()
    }
    return range
  },

  statusColor: state => (label) => {
    return state.statusColorMapping[label]
  },

  currentPage: state => {
    return state.currentPage
  },
}
